import Vue from 'vue';
import VueRouter from 'vue-router';

import Editor from '@/views/Editor.vue';
import InstanceEditor from '@/views/InstanceEditor.vue';
import NotFound from '@/views/NotFound.vue';
import PageList from '@/views/PageList.vue';
import TrashPage from '@/views/TrashPage.vue';
import MetricsDashboard from '@/views/MetricsDashboard.vue';
import InstanceList from '@/views/InstanceList.vue';
import Preview from '@/views/Preview.vue';
import PreviewOptions from '@/views/PreviewOptions.vue';
// eslint-disable-next-line import/extensions
import Login from '@/views/Login';
// eslint-disable-next-line import/extensions
import Settings from '@/views/Settings';
// eslint-disable-next-line import/extensions
import Dashboard from '@/views/Dashboard';

import store from '@/store';
import getToken from '@/helpers/getToken';
import { pushDataLayer, installGTM } from '@/helpers/gtm';
import i18n from '@/i18n';
import isV1Customer from './v1customers';

Vue.use(VueRouter);

const routes = [
  {
    path: '/admin',
    name: 'admin',
    meta: { label: 'Painel admin' },
    component: Dashboard,
    beforeEnter(to, from, next) {
      const hasPermission = store.getters.isGlobalUser;
      if (hasPermission) {
        next();
        return;
      }

      next('/');
    },
  },
  {
    path: '/',
    name: 'pagelist',
    meta: { label: 'Lista de páginas' },
    component: PageList,
    beforeEnter(to, from, next) {
      store.commit('SET_ACTIVE_GLOBAL_INSTANCE_ID', null);
      store.commit('SET_ACTIVE_MODAL_ID', null);
      store.commit('SET_ACTIVE_PAGE_ID', null);
      store.commit('SET_ACTIVE_INSTANCE', null);
      store.commit('SET_VALIDATION_PANEL_DISPLAY', null);
      store.dispatch('loadPages');
      next();
    },
  },
  {
    path: '/pop-ups',
    name: 'modallist',
    meta: { label: 'Lista de pop-ups' },
    component: InstanceList,
    beforeEnter(to, from, next) {
      store.commit('SET_ACTIVE_GLOBAL_INSTANCE_ID', null);
      store.commit('SET_ACTIVE_MODAL_ID', null);
      store.commit('SET_ACTIVE_PAGE_ID', null);
      store.commit('SET_ACTIVE_INSTANCE', null);
      store.commit('SET_VALIDATION_PANEL_DISPLAY', null);
      store.dispatch('loadGlobals', { endpoint: 'modals' });
      next();
    },
  },
  {
    path: '/editor/pop-up/:id',
    name: 'modaleditor',
    meta: { label: 'Editor de pop-ups' },
    component: InstanceEditor,
    async beforeEnter(to, from, next) {
      try {
        await store.dispatch('loadPages');
      } catch {
        next({ name: 'modallist' }); // TODO: redirect to not-found
      }

      store
        .dispatch('loadGlobal', { ...to.params, endpoint: 'modals' })
        .then((modal) => {
          i18n.locale = modal.language;
          store.commit('SET_ACTIVE_GLOBAL_INSTANCE_ID', null);
          store.commit('SET_ACTIVE_MODAL_ID', modal.id);
          store.commit('SET_ACTIVE_PAGE_ID', null);
          store.commit('SET_ACTIVE_INSTANCE', modal.id);
          store.commit('SET_VALIDATION_PANEL_DISPLAY', null);
          store.commit('SET_ACTIVE_INSTANCE', null);
          store.dispatch('validateActiveContainer');
          next();
        })
        .catch((reason) => {
          console.log(reason);
          next({ name: 'modallist' }); // TODO: redirect to not-found
        });
    },
  },
  {
    path: '/editor/:language/:urlPath+',
    name: 'editor',
    meta: { label: 'Editor de páginas' },
    component: Editor,
    async beforeEnter(to, from, next) {
      i18n.locale = to.params.language;

      try {
        await store.dispatch('loadPages');
      } catch {
        next({ name: 'pagelist' }); // TODO: redirect to not-found
      }

      store
        .dispatch('loadPage', to.params)
        .then(async (page) => {
          await store.dispatch('storePage', page);
          store.commit('SET_PRESET_LIST_DISPLAY', null);
          store.commit('SET_ACTIVE_GLOBAL_INSTANCE_ID', null);
          store.commit('SET_ACTIVE_MODAL_ID', null);
          store.commit('SET_ACTIVE_PAGE_ID', page.id);
          store.commit('SET_VALIDATION_PANEL_DISPLAY', null);
          store.commit('SET_ACTIVE_INSTANCE', null);
          store.dispatch('validateActiveContainer');
          next();
        })
        .catch((reason) => {
          console.log(reason);
          next({ name: 'pagelist' }); // TODO: redirect to not-found
        });
    },
  },
  {
    path: '/settings',
    name: 'settings',
    meta: { label: 'Configurações' },
    component: Settings,
  },
  {
    path: '/preview-iframe/:language/:urlPath+',
    name: 'preview-iframe',
    meta: { label: 'Preview' },
    component: Preview,
    async beforeEnter(to, from, next) {
      i18n.locale = to.params.language;

      try {
        await store.dispatch('loadPages');
        await store.dispatch('loadGlobals', { endpoint: 'globals' });
      } catch {
        next({ name: 'pagelist' }); // TODO: redirect to not-found
      }

      store
        .dispatch('loadPage', to.params)
        .then(async (page) => {
          await store.dispatch('storePage', page);
          store.commit('SET_ACTIVE_PAGE_ID', page.id);
          next();
        })
        .catch((reason) => {
          console.log(reason);
          next({ name: 'pagelist' }); // TODO: redirect to not-found
        });
    },
  },
  {
    path: '/preview/:language/:urlPath+',
    name: 'preview',
    meta: { label: 'Opções do preview' },
    component: PreviewOptions,
    async beforeEnter(to, from, next) {
      if (from.name === 'editor') {
        store.dispatch('saveActiveContainer');
      }

      try {
        await store.dispatch('loadPages');
        await store.dispatch('loadGlobals', { endpoint: 'globals' });
      } catch {
        next({ name: 'pagelist' }); // TODO: redirect to not-found
      }

      store
        .dispatch('loadPage', to.params)
        .then(async (page) => {
          await store.dispatch('storePage', page);
          store.commit('SET_ACTIVE_PAGE_ID', page.id);
          next();
        })
        .catch((reason) => {
          console.log(reason);
          next({ name: 'pagelist' }); // TODO: redirect to not-found
        });
    },
  },
  {
    path: '/trash',
    name: 'trash',
    meta: { label: 'Páginas excluídas' },
    component: TrashPage,
    beforeEnter(to, from, next) {
      store.commit('SET_ACTIVE_GLOBAL_INSTANCE_ID', null);
      store.commit('SET_ACTIVE_MODAL_ID', null);
      store.commit('SET_ACTIVE_PAGE_ID', null);
      store.commit('SET_ACTIVE_INSTANCE', null);
      store.commit('SET_VALIDATION_PANEL_DISPLAY', null);
      store.dispatch('loadDeletedPages');
      store.dispatch('loadPages');
      next();
    },
  },
  {
    path: '/metrics',
    name: 'metrics',
    meta: { label: 'Painel de Métricas' },
    component: MetricsDashboard,
    async beforeEnter(to, from, next) {
      store.commit('SET_LOADING_STATE', true);
      Promise.all([
        store.dispatch('loadLeadNumbers'),
        store.dispatch('loadBestLeadPages'),
        store.dispatch('loadSeoTotal'),
        store.dispatch('loadWorstSeoPages'),
      ])
        .catch((error) => {
          console.warn(error);
        })
        .then(() => store.commit('SET_LOADING_STATE', false));
      next();
    },
  },
  {
    path: '/login',
    name: 'login',
    meta: { label: 'Login' },
    component: Login,
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const userToken = getToken({ decoded: true });
  const hasToken = !!userToken;
  const isLoginUrl = to.name === 'login';
  const isGlobalUser = hasToken && userToken.global;
  const freshLoad = from.matched.length === 0;
  const { flow } = to.query;

  // V2 Redirects
  if (hasToken && userToken.aud) {
    const isV1 = await isV1Customer(userToken.aud);

    if (!isV1) {
      const tokenHash = getToken();

      if (window.location.hostname.includes('dev-editor')) {
        localStorage.removeItem('editor-token');
        window.location.href = `https://dev-admin.siteletsbook.com.br/#${tokenHash}`;
      } else {
        localStorage.removeItem('editor-token');
        window.location.href = `https://admin.siteletsbook.com.br/#${tokenHash}`;
      }

      return;
    }
  }
  // Fim V2 Redirects

  if (isLoginUrl) {
    if (hasToken && !flow) {
      // force refresh to load GTM
      window.location.href = `${window.location.origin}/`;
    }

    next();
    return;
  }

  if (!hasToken) {
    // user has no token and needs to login
    router.push({ path: '/login' });
    next();
    return;
  }

  const isTokenExpired = hasToken && userToken.exp < Date.now() / 1000;

  if (isTokenExpired) {
    localStorage.removeItem('editor-token');

    if (freshLoad) {
      router.push({ path: '/login' });
      next();
    } else {
      // eslint-disable-next-line no-alert
      alert('Seu acesso expirou, realize o login novamente.');
      window.location.href = '/login'; // force refresh to unload GTM
    }

    return;
  }

  store.commit('SET_LOGGED_USER', {
    email: userToken.email,
    name: userToken.name,
    global: userToken.global === true,
    role: userToken.role,
    origin: userToken.sub,
  });

  if (isGlobalUser && !userToken.aud) {
    if (to.name !== 'admin') {
      router.push({ path: '/admin' });
    }
    next();
    return;
  }

  store.commit('SET_CUSTOMER', userToken.aud);

  // Avoid installing GTM on preview iFrame, if it's already installed or it's localhost
  if (
    to.name !== 'preview-iframe' &&
    !window.google_tag_manager &&
    window.location.hostname !== 'localhost'
  ) {
    pushDataLayer({ customer: userToken.aud });
    installGTM();
  }

  // Load settings if visitor is coming from a good old full refresh
  if (freshLoad) {
    store
      .dispatch('loadCustomerSettings')
      .catch((error) => {
        if (error.response.status === 404) {
          // TODO: error handling
          console.warn('Cliente não existe');
        } else {
          console.warn(error);
        }
      })
      .finally(() => {
        next();
      });

    // Remove variável legado referente ao login
    localStorage.removeItem('editor-login-url');
  } else {
    next();
  }
});
export default router;
